export default __webpack_public_path__ + "static/media/risksmith-mark.9f2f854f.svg";